import { useEffect } from 'react';

export function isInput(element: HTMLElement) {
  return (
    element.tagName === 'INPUT' ||
    element.tagName === 'TEXTAREA' ||
    element.tagName === 'SELECT' ||
    element.contentEditable === 'true'
  );
}

interface UsePreventScrollProps {
  isDisabled?: boolean;
}

export function usePreventScroll({ isDisabled }: UsePreventScrollProps) {
  useEffect(() => {
    if (isDisabled) return;

    const preventScroll = (e: TouchEvent) => {
      if (e.touches.length === 1) {
        const target = e.target as HTMLElement;
        if (isInput(target)) return;

        e.preventDefault();
      }
    };

    document.addEventListener('touchmove', preventScroll, { passive: false });

    return () => {
      document.removeEventListener('touchmove', preventScroll);
    };
  }, [isDisabled]);
}
